import { IconSvg, IconSvgProps } from "./icon"

export default function Bed(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeModifier={0.875}>
      <path d="M17.063 4.324H6.938c-.622 0-1.125.504-1.125 1.125v14.626c0 .62.503 1.125 1.125 1.125h10.125c.62 0 1.125-.504 1.125-1.125V5.449c0-.62-.504-1.125-1.125-1.125Z" />
      <path d="M13.688 6.574h-3.376c-.62 0-1.124.504-1.124 1.125v1.125c0 .622.503 1.125 1.124 1.125h3.376c.62 0 1.124-.503 1.124-1.125V7.7c0-.62-.503-1.125-1.124-1.125ZM5.813 9.95h12.375M5.813 13.325h12.375" />
    </IconSvg>
  )
}
